const ORDER = [
  ["billing", "/billing"], ["dashboard", "/dashboard"], ["bill_history", "/bills"],
  ["products_view", "/products"], ["purchase", "/purchase"], ["customers", "/customers"],
  ["vendors", "/vendors"], ["expenses", "/expenses"], ["daybook", "/daybook"], ["reports", "/reports"],
];

export function firstAllowedPath(user) {
  if (!user) return "/billing";
  if (user.role === "super_admin") return "/billing";
  const perms = user.effective_permissions || {};
  for (const [p, path] of ORDER) if (perms[p]) return path;
  return "/settings";
}
